import React from 'react';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import { ALIGN_TYPE, Element, Icon, LIST_TYPE, Section, Title } from 'src/components';
import { ContentList } from '../../list';
import RouterLink from 'src/components/links';
import styles from './styles.module.scss';

interface IProps extends IBaseSection<IContent> {
    type?: LIST_TYPE;
    alignList?: ALIGN_TYPE;
    alignItem?: ALIGN_TYPE;
    ContentItemComponent?: React.FunctionComponent<any>;
    id: number;
    trackingKey?: string;
}

export default React.memo(function ContentLocationSection(props: IProps) {
    const {
        items = [],
        title,
        link = '',
        className = 'location-section',
        displayTimeIn,
        alignList,
        alignItem,
        type,
        ContentItemComponent,
        id,
        trackingKey = '|location',
    } = props;

    if (!items.length) {
        return null;
    }

    return (
        <Section className={cn(styles[className])}>
            <Title className={className} renderAs='h2'>
                <RouterLink to={link}>
                    <Icon icon="map-marker-alt" />
                    <Element renderAs="span">{title}</Element>
                </RouterLink>
            </Title>
            <ContentList
                items={items.slice(0, 2)}
                align={alignList}
                alignItem={alignItem}
                type={type}
                displayTimeIn={displayTimeIn}
                ContentItemComponent={ContentItemComponent}
                tracking={id ? trackingKey + id : ''}
            />
        </Section>
    );
});
